import React from "react";
import PropTypes from "prop-types";

import { Field, Control } from "rbx";

import UserGroupMembershipCheckGroup from "./UserGroupMembershipCheckGroup";

const UserGroupMembershipForm = ({ inputs, readOnly, onChange }) => (
  <React.Fragment>
    <Field kind="group">
      <Control expanded>
        <UserGroupMembershipCheckGroup
          inputs={inputs}
          readOnly={readOnly}
          onChange={onChange}
        />
      </Control>
    </Field>
  </React.Fragment>
);

UserGroupMembershipForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool
};
UserGroupMembershipForm.defaultProps = {
  inputs: {}
};
export default UserGroupMembershipForm;
